export const EXPERIMENTS = {
  USE_FIELDS_V2: 'specs.forms.UseFieldsV2',
  SUBMIT_STATUS_MESSAGE_VIEWER: 'specs.forms.SubmitStatusMessageViewer',
  ENABLE_SUBMIT_LIMITS_SETTINGS: 'specs.forms.EnableSubmitLimitsSettings',
  ENABLE_QUIZ_QUESTION_IMAGE: 'specs.forms.EnableQuizQuestionImage',
  REMOVE_PHONE_DEFAULT_VALUE: 'specs.forms.RemovePhoneDefaultValueComposer',
  LOCAL_PHONE_NUMBERS: 'specs.forms.LocalPhoneNumbers',
  SHOW_DATE_LABELS_SETTINGS: 'specs.forms.FieldGroupNameSettings',
  APPOINTMENT_FIELD_V11: 'specs.forms.EnableAppointmentFieldV11',
  ENABLE_RICH_TEXT_SETTINGS: 'specs.forms.EnableRichTextSettings',
  SIGNATURE_FIELD_V2: 'specs.forms.SignatureFieldV2'
};
//# sourceMappingURL=experiments.js.map